import React from "react";

const InputFieldShadow = ({
  name = "name",
  label = "Label",
  type = "text",
  icon,
  error,
  value,
  ...rest
}) => {
  return (
    <div>
      <div
        className={`input-gradient-border px-5 py-1 flex items-center gap-2 transition-all duration-600 ${
          error ? "border-danger" : ""
        }`} // Move focus styles here
      >
        <div className="w-full">
          <input
            type={type}
            name={name}
            value={value}
            autoComplete="off"
            placeholder=" " // Placeholder for triggering floating label
            className="peer  py-3 w-full mt-0 bg-transparent appearance-none outline-none ring-0 focus:outline-none text-sm transition-all duration-600 relative z-20"
            {...rest}
          />
          <label
            className="select-none absolute px-1 left-3 -top-5 z-10 text-neutrals text-xs transition-all duration-600
          peer-placeholder-shown:text-sm peer-focus:text-xs peer-focus:z-30
          peer-placeholder-shown:top-4 peer-focus:-top-5
          "
          >
            {label}
          </label>
        </div>

        {icon && (
          <div className="flex items-center">
            <span className="material-symbols-outlined w-[20px] h-[20px] text-[20px] text-gray-400 leading-none select-none">
              {icon}
            </span>
          </div>
        )}
      </div>
      {error && (
        <div className="infoMessage font-light text-danger-200 p-1">
          Special characters are not allowed
        </div>
      )}
    </div>
  );
};

export default InputFieldShadow;
